/**
 * 단어 이운이의어 화면.
 * 초기 방식이 너무 느려서 속도를 높이기 위해서 새로 만든 방식. (HomonymComponent를 대체함)
 */
import {ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationStart, Router} from "@angular/router";
import {Location} from "@angular/common";
import {Subject, Subscription, timer} from "rxjs";
import {auditTime, debounceTime, delay, filter, finalize, share} from "rxjs/operators";

import {IsEqualObj1} from "../../shared/defines/common.func";
import {
  DETAIL_POPUP_DELAY, HISTORY_KEY_SEARCH_HOMONYM, HOMONYM_DISP_TYPE,
  HOMONYM_SCROLL_SPEED, REPLACE_URL_AUDIT_TIME, SCROLL_DEBOUNCE_TIME_HOMONYM,
  SearchParam,
  UI_RELOAD_HEIGHT_HOMONYM
} from "../../shared/defines/client.const";
import {JASO} from "../../shared/defines/gukeo.const";
import {ListLoader} from "../../shared/interfaces/list-loader";
import {Homonym} from "../../shared/models/homonym.model";
import {generateUrlWithQueryParams, GetSearchFromQuery} from "../../shared/defines/client.func";
import {NormalizeSearchParamKeyword} from '../../shared/defines/search-keyword.func';
import {HeaderComponent} from "../../shared/components/header/header.component";
import {OptionService} from "../../shared/services/option/option.service";
import {VoiceService} from "../../shared/services/voice/voice.service";
import {HomonymService} from "../../shared/services/homonym/homonym.service";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";
import {ScrollDownService} from "../../shared/services/scroll-down/scroll-down.service";
import {LastIdService} from "../../shared/services/last-id/last-id.service";
import {LayoutMgrService} from "../../shared/services/layout-mgr/layout-mgr.service";


@Component({
  selector: 'app-homonym2',
  templateUrl: './homonym2.component.html',
  styleUrls: ['./homonym2.component.scss']
})
export class Homonym2Component implements OnInit, OnDestroy {
  @ViewChild('container') container: ElementRef;
  @ViewChild(HeaderComponent) header: HeaderComponent;
  @ViewChild('reload') reload: ElementRef;

  readonly HISTORY_KEY_SEARCH_HOMONYM = HISTORY_KEY_SEARCH_HOMONYM;

  initPage = false;

  public showDetail = false;  // 상세 팝업창이 열렸는지 여부
  public curHomonym: string = null; // 현재 선택된 이운이의어

// 라우터에서 넣어주는 값. (TODO: 초기화에 유의해야 함)
  private queryParams: SearchParam = null;
  private queryParams$: Subscription = null;
  private routeParams$: Subscription = null;

// 해더에 넣는 값
  public curJasoIdx: JASO | null = null;

// ListLoader 설정
  public ll: ListLoader<Homonym>;


  private getNextList$: Subscription = null;
  private needReload = false;

  // 라우팅 처리
  private router$?: Subscription | null = null;

  // 라우팅 컨트롤 변수
  private scrollEvent$: Subject<void>;
  private scrollEvent$$: Subscription;
  private replaceUrl$: Subject<string>;
  private replaceUrl$$: Subscription;

  // 푸터의 아래로 내리기 버튼 구독
  private scrollDown$: Subscription | null = null;

  private get routeHomonym(): string {
    return '/homonym';
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private zone: NgZone,
    private cdRef: ChangeDetectorRef,
    private option: OptionService,
    private voice: VoiceService,
    private homonymSvc: HomonymService,
    private globalEventSvc: GlobalEventService,
    private scrollDownSvc: ScrollDownService,
    private lastIdSvc: LastIdService,
    public lm: LayoutMgrService,
    private location: Location,
  ) {
    /******************************************************************************************
     * 라우터 파리미터 변경 핸들러 - 주소 뒤의 파라미터를 받아오는 곳. ( ?keyword=... )
     * 입력된 파라미터가 없어도 처음 초기화 할 때에도 불려진다.
     * 처음 화면에 들어올 때, 라우터 주소 변견 핸들러보다 더 먼저 불려진다. (이상하지만 그렇다)
     *
     * router.navigate()로 같은 주소를 호출하면 이 코드가 다시 불려진다.
     */
    this.queryParams$ = this.route.queryParams.subscribe(params => {
      console.log('queryParams =', params);
      const oldParams = {...this.queryParams};
      this.queryParams = NormalizeSearchParamKeyword({...params});
      delete this.queryParams.serial;

      // if (this.option.homonymDisp !== HOMONYM_DISP_TYPE.SIMPLE) {
      //   this.router.navigate(['/homonym'], {
      //     queryParams: params,
      //     replaceUrl: true,
      //   });
      // }

      if (this.initPage) {  // 이미 로딩된 경우 == 화면이 생성된 상태

        if ('id' in this.queryParams) {
          const id = this.queryParams.id;
          // console.log('queryParams:: id=', id);

          const processParams = () => {
            const homonym = this.homonymSvc.getById(id) ?? null;
            // console.log('queryParams:: homonym=', homonym);

            if (homonym) {
              // 현재 상세 팝업창을 닫고, 새로운 단어로 다시 연다.
              this.CloseDetail();
              timer(DETAIL_POPUP_DELAY).subscribe(() => {
                this.OpenDetailPopup(homonym.name);
              });
            } else {
              // 존재하지 ㅇ낳으면, 해당 단어를 시작으로 로딩한다.
              console.warn("does not exist homonym", this.queryParams.id);
            }
          };

          if (this.homonymSvc.IsLoading()) {
            this.homonymSvc.GetNextList().pipe(
              delay(DETAIL_POPUP_DELAY),
            ).subscribe(processParams);
          } else {
            processParams();
          }
        } else {
          // id 가 없는 경우

          const params = {...oldParams};
          delete params.id;
          if (IsEqualObj1(params, this.queryParams)) {
            // 기존의 값과 id 만 빼고 동일하다면, 현재 상세 팝업창을 닫는다.
            this.CloseDetail();
          } else {
            // 기존 파라미터와 다르면, 다시 로딩한다.
            this.init();
          }
        }
      }
    });

    /******************************************************************************************
     * 라우터 주소 변경 핸들러 - 라우터 주소 읽어오는 곳.
     * 라우터 주소에 포함된 파라미터가 변경되어도 불려진다. (여기서는 type만 변경되어도 불려짐)
     *
     * queryParams가 바뀐 것(주소뒤의 파리미터가 변경된 경우)으로는 여기가 불려지지 않는다.
     */
    this.routeParams$ = route.params.subscribe(params => {
      this.init();

      this.initPage = true;
    });

    this.resetScroll();

    lm.Reset();
  }

  ngOnInit(): void {
    this.router$ = this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
    ).subscribe((event) => {

      // base url이 변경될 때만 호출
      const curBasePath = this.router.url.split('?')[0]; // 현재의 base url
      const tarBasePath = (event as NavigationStart).url.split('?')[0]; // 이동할 base url
      if (curBasePath !== tarBasePath) {
        this.onLeave();
      }
    });

    // 푸터의 스크롤 버튼 처리.
    this.scrollDown$ = this.scrollDownSvc.pushScrollDown$().subscribe(isFirst => {
      if (isFirst) {
        this.onCloseItem();
      }
      const scrollDelta = HOMONYM_SCROLL_SPEED * (isFirst ? 2 : 1);  // 스크롤 시작할 때 첫번째는 두배로 스크롤 함.

      this.container?.nativeElement.scrollTo({
        top: this.container.nativeElement.scrollTop + scrollDelta,
        behavior: 'auto',
      });

      // if (this.container?.nativeElement) {
      //   animateScrollTo(this.container.nativeElement.scrollTop + scrollDelta, {
      //     elementToScroll: this.container.nativeElement,
      //     // speed: 400,
      //     maxDuration: LIST_SCROLL_INTERVAL - 5,
      //   }).then();
      // }
    });
  }

  ngOnDestroy() {
    // 화면전환시 라우팅을 위해서 히스토리 저장

    if (this.getNextList$) {
      this.getNextList$.unsubscribe();
      this.getNextList$ = null;
    }
    if (this.router$) {
      this.router$.unsubscribe();
      this.router$ = null;
    }
    if (this.queryParams$) {
      this.queryParams$.unsubscribe();
      this.queryParams$ = null;
    }
    if (this.routeParams$) {
      this.routeParams$.unsubscribe();
      this.routeParams$ = null;
    }
    if (this.scrollEvent$$) {
      this.scrollEvent$$.unsubscribe();
      this.scrollEvent$$ = null;
    }
    if (this.replaceUrl$$) {
      this.replaceUrl$$.unsubscribe();
      this.replaceUrl$$ = null;
    }

    this.scrollDownSvc.popScrollDown$();
    if (this.scrollDown$) {
      this.scrollDown$.unsubscribe();
      this.scrollDown$ = null;
    }

    this.CloseDetail();
  }

  private init(): void {
    // console.warn('init()');

    this.voice?.Stop();
    this.showDetail = false;
    this.curHomonym = null;
    this.CloseDetail();

    let param: SearchParam;
    this.ll = this.homonymSvc;
    [param, this.curJasoIdx] = GetSearchFromQuery(this.queryParams);
    // [param, this.curJasoIdx] = GetSearchFromQuery(this.queryParams, 'ㄱ');
    // if (this.queryParams?.id && !this.queryParams.start) {
    //   param.start = this.queryParams.id;
    // }
    this.ReloadList(param);
  }

  private onLeave(): void {
    const top: Homonym = this.scrollTopTarget;

    if (!('keyword' in this.queryParams) // 검색어가 없는 경우만 start를 붙임.
      && top) {
      const top_name = (this.queryParams?.id && this.queryParams.id < top.name) ? this.queryParams.id : top.name;

      const queryParam: SearchParam = {
        ...(this.queryParams ? this.queryParams : {}),
        start: top_name,
      }
      const basePath = this.router.url.split('?')[0];  // query parameter를 제거
      const urlWithParams = generateUrlWithQueryParams(basePath, queryParam);
      console.warn('HomonymComponent::replaceUrl$ urlWithParams =', urlWithParams);

      // URL 변경
      this.location.replaceState(urlWithParams);

      this.lastIdSvc.setLastHomonymId(this.curHomonym ?? null, top.name);
    }
  }

  /****************************************************************************
   * 단어 목록 로딩 처리.
   ****************************************************************************/
  public ReloadList(param: SearchParam): void {
    // console.warn('ReloadList() param =', param);

    // 단어 이력보기 화면에서 자소를 선택하면 단어 검색으로 변경한다.
    // if (this.ll instanceof WordHistoryService && ('index' in param || 'keyword' in param)) {
    //   console.warn('ReloadWordList:: ll, param', this.ll, param);
    //   this.router.navigate(['/word', LIST_TYPE.SERVER], {
    //     queryParams: {...param}
    //   }).then();
    //   return;
    // }

    this.ll.ResetList(param);
    this.loadList(true);

    // 새 조건으로 목록을 재로딩할 때 목록 스크롤을 최상단으로 되돌린다. (#602)
    this.scrollListToTop();

    // 상세 팝업창이 열려있다면 닫는다.
    if (this.showDetail) {
      this.CloseDetail();
    }
  }

  /**
   * 목록을 새로 로딩할 때 컨테이너 스크롤을 최상단(0)으로 되돌린다. (#602)
   *
   * iOS(Cordova) WKWebView 는 관성(momentum) 스크롤이 진행 중일 때 `scrollTop = 0`
   * 대입을 무시한다. 그래서 목록을 손가락으로 스크롤(=관성 활성)하다가 색인/검색을
   * 바꾸면, 재로딩이 빠르게 끝나 관성이 아직 살아있는 경우 리셋이 덮여 이전 위치가
   * 남는다. (느린 재로딩은 관성 종료 후 리셋되어 정상, 웹·안드로이드는 관성이
   * 프로그램적 스크롤을 덮지 않아 정상.) overflow 를 잠깐 hidden 으로 만들어 관성을
   * 끊고 최상단으로 고정한 뒤 원복한다. word 화면과 동일 대응(#602, PR #603).
   *
   * 이 메서드는 전체 재로딩 경로(`ReloadList()`)에서만 호출되므로 상세 열기/닫기
   * (`id` 변경)나 무한 스크롤 페이지네이션에는 영향을 주지 않는다.
   * @private
   */
  private scrollListToTop(): void {
    const el = this.container?.nativeElement;
    if (!el) {
      return;
    }
    // overflow 를 잠깐 없애 관성 스크롤을 끊고 최상단으로 고정한다. (iOS WKWebView 대응)
    const prevOverflowY = el.style.overflowY;
    el.style.overflowY = 'hidden';
    el.scrollTop = 0;
    void el.offsetHeight;              // 강제 reflow 로 관성 취소를 커밋
    el.style.overflowY = prevOverflowY;
    el.scrollTop = 0;

    // 새 목록 DOM 재렌더 이후에도 최상단을 유지한다. (렌더 타이밍 안전망)
    timer(0).subscribe(() => {
      const c = this.container?.nativeElement;
      if (c) {
        c.scrollTop = 0;
      }
    });
  }


  /**
   *
   * @param cancel - 기존의 로딩을 무시하고 다시 로딩. (다른 이운이의어 검색 하는 경우, 기존 검색은 취소)
   * @private
   */
  private loadList(cancel = false): void {
    // console.warn('loadList() homonymQueue.length =', this.homonymQueue.length);
    if (this.getNextList$) {
      console.warn('HomonymComponent::loadWordList() already loading!');
      if (cancel) {
        this.getNextList$.unsubscribe();
      }
      else {
        return;
      }
    }

    if (this.ll.IsComplete()) {
      console.warn('HomonymComponent::loadWordList() already load all word!');
      return;
    }

    const sharedObservable$ = this.ll.GetNextList().pipe(share());

    this.getNextList$ = sharedObservable$.pipe(
      finalize(() => {
        this.getNextList$ = null;

        if (this.needReload) {
          timer(100).subscribe(() => {
            this.needReload = false;
            this.loadList();
          });
        }
      })
    ).subscribe(data => {
      // console.warn('is Open?', this.queryParams);

      // this.BoxLoad();

      if (this.queryParams && 'id' in this.queryParams) {
        // 바로 보기 상태라면, 서버로부터 로딩이 완료되고 나서 바로 상세 화면을 연다.
        // this.replaceState({id: this.queryParams.id, start: this.ll?.getList()[0]?.name});
        const homonym = this.ll.getById(this.queryParams.id);
        if (homonym) {
          this.OpenDetailPopup(homonym.name);
        }
      } else {
        // 인덱스 검색시 start queryparams 첫번째 단어로 정의
        // this.replaceState({start: this.ll?.getList()[0]?.name});
      }
    }, err => console.error(err));


    // 새로 항목이 로딩 된 뒤에, 주소를 변경한다.
    // sharedObservable$.pipe(
    //   delay(DETAIL_POPUP_DELAY + HOMONYM_REPOSITION_DELAY),
    // ).subscribe(ret => {
    //   if (ret.list?.length > 0) {
    //     // 이전에 진행하던 작업을 모두 취소하고 다시 넣는다.
    //     this.resetScroll();
    //
    //     const firstItem = ret.list[0];
    //     this.replaceUrl$.next(firstItem.name);
    //   } else {
    //     console.log('ret.list is empty');
    //   }
    // });
  }


  /****************************************************************************
   * 상세 팝업창 처리
   ****************************************************************************/

  onSelectItem($event: MouseEvent, homonym: Homonym): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    if (this.showDetail) {
      console.warn('HomonumComponent::onSelectItem() already show detail popup!');
      return
    }

    // const topId = this.scrollTopTarget?.name ?? null;
    // if (topId) {
    //   this.queryParams.start = topId;
    // }

    const queryParams: SearchParam = {
      ...this.queryParams,
      id: homonym.name,
    }
    this.router.navigate([this.routeHomonym], {queryParams}).then();

    this.resetScroll();
  }

  public onCloseItem(): void {
    const queryParams: SearchParam = this.queryParams
    delete queryParams.id;

    this.router.navigate([this.routeHomonym], {queryParams}).then();
  }


  public OpenDetailPopup(homonym: string): void {
    console.log('HomonumComponent::onDetailPopup() event=', event);

    this.curHomonym = homonym;
    this.showDetail = true;

    //TODO: 여기는 스크롤 무빙 적용을 안하는가?
  }


  public CloseDetail(close: boolean = false): void {
    // 클로즈 버튼을 직접 눌렀을때만 수행

    if (this.curHomonym) {
      this.curHomonym = null;
    }
    this.showDetail = false;
    this.voice.Stop();

    // 현재 책갈피 화면이라면, 닫을 때 해당 단어를 제거한다.
    // if (this.ll instanceof WordBookmarkService) {
    //   this.bmSvc.hideBookmark(this.curWordDetail.id);
    // }
  }

  /****************************************************************************
   * 일정 범위 이상 스크롤되면 남은 단어를 자동 로딩한다.
   ****************************************************************************/
  onScroll($event): void {
    if (!this.ll.IsLoading() && !this.ll.IsComplete()) {
      const tar = $event.target || $event.srcElement || $event.currentTarget;
      if (tar !== this.container.nativeElement) {
        console.error('HomonymComponent::onScroll() - wrong structure!!');
      }
      // console.log('onScroll() event =', $event,. tar);

      const elReload = this.reload.nativeElement;
      // console.log('onScroll() ', elReload.offsetTop, elReload.scrollTop, tar.offsetTop, tar.scrollTop, window.innerHeight);
      // console.warn('onScroll() ', elReload.offsetTop, window.innerHeight + tar.scrollTop);
      if (elReload.offsetTop < window.innerHeight + tar.scrollTop + UI_RELOAD_HEIGHT_HOMONYM) {
        if (this.getNextList$ === null) {
          this.loadList();
        } else {
          this.needReload = true;
        }
      }
    }

    if (!this.showDetail) {
      this.scrollEvent$.next();
    }
  }

  /**
   * 뒤로가기 할 때 현재의 화면 상태를 저장하기 위한 루틴
   * @private
   */
  private resetScroll(): void {
    console.warn('WordComponent::resetScroll()');

    if (this.scrollEvent$$) {
      this.scrollEvent$$.unsubscribe();
    }
    if (this.replaceUrl$$) {
      this.replaceUrl$$.unsubscribe();
    }

    this.scrollEvent$ = new Subject<void>();

    /**
     * 일정 시간 기다리는 동안 새로운 값이 들어오면 또 일정 시간을 다시 기다린다.
     * (새로운 값이 들어오면 대기 시간 연장)
     */
    this.scrollEvent$$ = this.scrollEvent$.pipe(
      debounceTime(SCROLL_DEBOUNCE_TIME_HOMONYM)  // 2000ms 이내로 이벤트가 들어오면 이전 것을 무시. 이운이의어는 2배로 늘임.
    ).subscribe(event => {
      console.warn('HomonymComponent::scrollEvent$');

      const top: Homonym = this.scrollTopTarget;
      if (top) {
        this.replaceUrl$.next(top.name);
      }
    });


    this.replaceUrl$ = new Subject<string>();

    /**
     * 일정 시간 동안 기다린 후, 최종 값을 사용함.
     * (새로운 값이 들어와도 대기 시간 연장 안함)
     */
    this.replaceUrl$$ = this.replaceUrl$.pipe(
      auditTime(REPLACE_URL_AUDIT_TIME),
      filter(() => !('keyword' in this.queryParams)),
    ).subscribe((id: string) => {
      const queryParam: SearchParam = {
        ...(this.queryParams ? this.queryParams : {}),
        start: id,
      }
      const basePath = this.router.url.split('?')[0];  // query parameter를 제거
      const urlWithParams = generateUrlWithQueryParams(basePath, queryParam);
      console.warn('HomonymComponent::replaceUrl$ urlWithParams =', urlWithParams);

      // URL 변경
      this.location.replaceState(urlWithParams);

      this.lastIdSvc.setLastHomonymId(this.curHomonym, id);
    });
  }


  /****************************************************************************
   * 단어 도움말 팝업창 처리 코드
   ***************************************************************************/

  public OpenHelp(): void {
    this.lm.showHelp = true;
  }

  public CloseHelp(showSaseung: boolean | null = null): void {
    this.lm.showHelp = false;

    if (showSaseung !== null) {
      this.option.showSaseung = showSaseung;
    }
  }

  public ClosePitchHelp(): void {
    this.lm.showPitchHelp = false;
  }

  /****************************************************************************
   * 인덱스 서칭
   ***************************************************************************/

  onSearch(param: SearchParam) {
    this.router.navigate([this.routeHomonym], {queryParams: NormalizeSearchParamKeyword(param)}).then();

    /**
     * 검색어가 변경되면, URL 변경 작업중인 것들을 중단한다.
     */
    this.resetScroll();

    // 마지막 단어 설정을 지운다.
    this.lastIdSvc.clearLastHomonymId();
  }



  /****************************************************************************
   * 스크롤시 상단 아이템 정보 얻어오기
   ***************************************************************************/
  private lastWordIndex: number | null = null;
  private lastScrollTop: number = 0;

  private get scrollTopTarget(): Homonym | undefined {
    const elContainer = this.container?.nativeElement;
    if (!elContainer) {
      return undefined;
    }
    const homonyms = this.ll.getList();
    if (!homonyms || homonyms.length === 0) {
      this.lastWordIndex = null;
      return undefined;
    }

    // const currentScrollTop = elContainer.scrollTop + this.header.height;
    const currentScrollTop = elContainer.scrollTop;
    // console.warn('scrollTopTarget:: currentScrollTop =', currentScrollTop, elContainer.scrollTop, this.header.height, homonyms);

    // 이진 검색을 사용하여 적절한 항목 찾기
    let start = 0;
    let end = homonyms.length - 1;
    let mid = 0;

    while (start <= end) {
      mid = Math.floor((start + end) / 2);
      const homonym = homonyms[mid];

      if (homonym.offsetTop <= currentScrollTop && (mid === homonyms.length - 1 || homonyms[mid + 1].offsetTop > currentScrollTop)) {
        break;
      } else if (homonym.offsetTop > currentScrollTop) {
        end = mid - 1;
      } else {
        start = mid + 1;
      }
    }

    this.lastWordIndex = mid;
    this.lastScrollTop = currentScrollTop;
    return homonyms[mid];
  }
}
